import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconFlagGB(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <mask id="icon-flag-gb" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <circle cx="12" cy="12" r="12" fill="#fff" />
      </mask>
      <g mask="url(#icon-flag-gb)">
        <path
          d="M0 1.5A1.5 1.5 0 0 1 1.5 0h21A1.5 1.5 0 0 1 24 1.5v21a1.5 1.5 0 0 1-1.5 1.5h-21A1.5 1.5 0 0 1 0 22.5v-21Z"
          fill="#00247D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.098 12 0 9.75V3l12 5.586L24 3v6.75L18.903 12 24 14.25V21l-12-5.586L0 21v-6.75L5.098 12Z"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.422 12 0 8.25V4.5l12 5.711L24 4.5v3.75L15.578 12 24 15.75v3.75l-12-5.711L0 19.5v-3.75L8.422 12Z"
          fill="#CF142B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.75 15.75V24h-7.5v-8.25H0v-7.5h8.25V0h7.5v8.344H24v7.406h-8.25Z"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.75 9.75V0h4.5v9.75H24v4.5h-9.75V24h-4.5v-9.75H0v-4.5h9.75Z"
          fill="#CF142B"
        />
        <circle cx={12} cy={12} r={11.5} stroke="#3C3C60" strokeOpacity={0.1} />
      </g>
    </BaseIcon>
  );
}
